import PropTypes from 'prop-types'
import React from 'react'

import { Footnote } from '@thebeansgroup/sb_ui/typography'
import Colours from '@thebeansgroup/ui_style_helpers/colours'

import styles from './styles'

function InputLabel(props) {
  return (
    <label
      id={props.id}
      style={styles.base}
      htmlFor={props.htmlFor}
    >
      <Footnote
        variant='semibold'
        component='span'
        colour={Colours('grey', '500')}
      >
        {props.value}
      </Footnote>
      {renderOptional()}
    </label>
  )

  function renderOptional() {
    if (!props.optional) return null

    return (
      <Footnote
        component='span'
        colour={Colours('grey', '350')}
      >
        {' (optional)'}
      </Footnote>
    )
  }
}

InputLabel.defaultProps = {
  optional: false
}

InputLabel.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  optional: PropTypes.bool
}

export default InputLabel
